import { render, staticRenderFns } from "./tis-home.vue?vue&type=template&id=088a10a7&scoped=true&"
import script from "./tis-home.vue?vue&type=script&lang=js&"
export * from "./tis-home.vue?vue&type=script&lang=js&"
import style0 from "./tis-home.vue?vue&type=style&index=0&id=088a10a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088a10a7",
  null
  
)

export default component.exports